import { useMantineColorScheme } from "@mantine/core"

export const useSvgStyle = () => {
  const { colorScheme } = useMantineColorScheme()
  return {
    fill: colorScheme === "dark" ? "#fff" : "#000",
  }
}
